import React from 'react';
import './App.css';
import Main from './layout/Main';

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
